import React from 'react';
import PropTypes from 'prop-types';

export default class LeadsFunnelRow extends React.Component {
  static propTypes = {
    count: PropTypes.number,
    handleFilterChange: PropTypes.func,
    label: PropTypes.string,
    moveToTab: PropTypes.func,
    status: PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    }),
    totalCount: PropTypes.number
  };

  percentage() {
    if (this.props.totalCount == 0) return 0;

    return (this.props.count / this.props.totalCount) * 100;
  }

  labelName() {
    if (this.props.status) return this.props.status.label;

    return this.props.label || '';
  }

  statusId() {
    return this.props.status ? this.props.status.id : null;
  }

  onClickCount = (event) => {
    this.props.handleFilterChange({ leadStatus: Number(event.target.dataset.status) });
    this.props.moveToTab();
  }

  render() {
    const emptyClass = this.percentage() == 0 ? 'empty' : '';
    const style = { width: `${this.percentage()}%` };

    return (
      <tr>
        <td>
          <div className="pr-3 pt-4 text-nowrap" name="lead-label">{this.labelName()}</div>
        </td>
        <td width="80%">
          <div className="position-relative">
            <div className="pl-3 lead-graph empty" />
            <div className={`pl-3 lead-graph ${emptyClass}`} style={style}>
              {this.props.handleFilterChange && this.props.moveToTab ? (
                <a data-status={this.statusId()} onClick={this.onClickCount}>{this.props.count}</a>
              ) : (
                <span>{this.props.count}</span>
              )}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}
